import * as Faker from 'faker';

export const colorFactory = () => {
  const red = Number(Faker.datatype.number(255)).toString(16).toUpperCase();
  const green = Number(Faker.datatype.number(255)).toString(16).toUpperCase();
  const blue = Number(Faker.datatype.number(255)).toString(16).toUpperCase();
  return `#${red}${green}${blue}`;
};
